import { ref } from "vue";

export type ConsoleTheme = "light" | "dark";

/**
 * 跟随金山云全局导航（base.js）的 light/dark 主题。
 * 公有云才有 __ksStorage__（见 public/index.html），私有云恒为 light。
 *
 * on 的框架实现是"总线已有当前值则注册时立即回调一次，之后持续监听"，
 * 因此无需单独读取初始值 —— 无论本应用挂载早于或晚于 base.js 的首次
 * dispatch，都能拿到正确主题。
 */
export function useConsoleTheme() {
  const theme = ref<ConsoleTheme>("light");

  if (typeof window !== "undefined" && window.__ksStorage__) {
    window.__ksStorage__.on("theme", t => {
      theme.value = t === "dark" ? "dark" : "light";
    });
  }

  return { theme };
}
